<template>

    <section class="hero flex">
        <div class="hero-body flex_block">
            <div class="container has-text-centered">
                <IconWarning class="icon_warning" />
                <h1 class="error_title title is-size-2">{{ $t('modules.candidates.tokenError.title') }}</h1>
                Erreur de token
                <p>{{ $t('modules.candidates.tokenError.notice1') }}</p>
                <p>{{ $t('modules.candidates.tokenError.notice2') }}</p>
            </div>
        </div>
    </section>

</template>

<script>
export default {
    name: 'CandidateTokenError',
    components: {},
    data(){
        return {}
    },
    computed: {

    },
    methods: {

    }
}

</script>

<style lang="scss">

.survey_section{
    display: flex;
    .hero{
        .flex_block{
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 200px;
        }
    }
}
.icon_warning{
    width: 100px;
    fill: $danger;
}
.error_title{
    color: $danger!important;
}

</style>